<div class="containter-section">
  <button mat-icon-button (click)="triggerButton()">
    <div
      matBadge="{{ quantity() | badgePipe }}"
      [class]="badgeClasses()"
      [style]="badgeStyles()">
      <div class="icon-style" [class]="iconClasses()" [style]="iconStyles()">
        <ng-content></ng-content>
      </div>
    </div>
  </button>
  <span class="cdk-visually-hidden"> bagde </span>
</div>
